import ascending from "./ascending.js";
import maxIndex from "./maxIndex.js";
export default function greatestIndex(values, compare) {
    if (compare === void 0) { compare = ascending; }
    if (compare.length === 1)
        return maxIndex(values, compare);
    var maxValue;
    var max = -1;
    var index = -1;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        ++index;
        if (max < 0
            ? compare(value, value) === 0
            : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}
